import { useMutation } from '@apollo/client';
import { GRAPHQL_CONFIGURACOES_UNIDADE_PARAMETROS } from 'gql/unidade';
import { useCallback } from 'react';
import { IUnidade } from '../../../../types/modules/unidade';

export const useToggleDeslocamento = () => {
    const [toggleDeslocamento, { loading: loadingToogleDeslocamento }] = useMutation(
        GRAPHQL_CONFIGURACOES_UNIDADE_PARAMETROS
    );
    const handleToogleDeslocamento = useCallback(
        ({ id, unidadeParametro }: IUnidade) => {
            const deslocamentoAtivo = unidadeParametro?.find(
                ({ chave }) => chave === 'DESLOCAMENTO::ATIVO'
            )?.valor === 'YES';
            const unidadeParametroFilter = (unidadeParametro || []).filter(
                ({ chave }) => chave !== 'DESLOCAMENTO::ATIVO'
            ).map(({ chave, valor }) => ({ chave, valor }));
            toggleDeslocamento({
                variables: { unidadeId: id, data: [
                    ...unidadeParametroFilter,
                    {
                        chave: 'DESLOCAMENTO::ATIVO',
                        valor: deslocamentoAtivo ? 'NO' : 'YES',
                    },
                ] },
            });
        },
        [toggleDeslocamento]
    );
    return {
        handleToogleDeslocamento,
        loadingToogleDeslocamento,
    };
};
